import { useEffect, useRef } from 'react';
export function useStableEvent(eventName, elementRef, handler) {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;
    useEffect(() => {
        if (elementRef === null)
            return;
        const listener = (event) => handlerRef.current(event); // use most recent cb value when event handler runs
        const refElem = elementRef === window || elementRef === document
            ? elementRef
            : elementRef.current;
        refElem?.addEventListener(eventName, listener);
        // eslint-disable-next-line consistent-return
        return () => {
            refElem?.removeEventListener(eventName, listener);
        };
    }, [eventName, elementRef]);
}
